import { useParams, useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import ApiService from '../../services/api-service';
import cookieStorage from '../../services/cookie-storage';
import { getUserId } from '../../constants/function';
import { v4 as uuidv4 } from 'uuid';
import { UserContext } from '../../context/userContext';

export default function AddUsersToStream() {
    const { userCount, streamId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        addUsersToStream();
    }, [userCount, history]);

    const addUsersToStream = async () => {
        try {
            const response = await ApiService.addUsersToStream({
                streamId, userCount
            });

            history.push('/app');

        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return null;
}
